import { observable, action, runInAction } from 'mobx';
import { isEmpty, trim, cloneDeep } from 'lodash';
import { SelectChangeEvent } from '@mui/material';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

import Service from '@service/login';
import moSingle, { industryInit } from '@comp/modal/store/single-industry';
import moInfo from '@store/info';

const moSetting = observable({
  industry: <any>'', // 我所在行业
  job: <any>'', // 我的角色
  // 非必填项
  city: <any>'', // 我所在的城市
  cityCode: <number | string>'',
  scale: <any>'', // 企业规模
  scaleCode: <number | string>'',
  nature: <any>'', // 企业性质
  natureCode: <number | string>'',
  industryEmpty: false,
  roleEmpty: false,
});

const reset = action(() => {
  const { cityList, scaleList, natureList } = moInfo;
  const { industryList } = moSingle;
  const industry = localStorage.getItem('regIndustry') || '';
  const city = localStorage.getItem('regCity') || '';
  let cityCode = '';
  const scale = localStorage.getItem('regScale') || '';
  let scaleCode = '';
  const nature = localStorage.getItem('regNature') || '';
  let natureCode = '';

  cityList.map((item: any) => {
    if (item.name === city) cityCode = item.code;
  });
  scaleList.map((item: any) => {
    if (item.name === scale) scaleCode = item.code;
  });
  natureList.map((item: any) => {
    if (item.name === nature) natureCode = item.code;
  });

  moSetting.industry = industry;
  moSetting.city = city;
  moSetting.cityCode = cityCode;
  moSetting.scale = scale;
  moSetting.scaleCode = scaleCode;
  moSetting.nature = nature;
  moSetting.natureCode = natureCode;
  moSetting.job = '';
  moSetting.industryEmpty = false;
  moSetting.roleEmpty = false;

  industryInit();
});

// 选择我所在行业
const changeIndustry = action((ev: SelectChangeEvent<unknown>) => {
  // console.log('我的角色 -- ', ev.target.value);
  moSetting.industryEmpty = false;
  moSetting.industry = ev.target.value;
});

const resetIndustryEmpty = action(() => {
  moSetting.industryEmpty = false;
});

// 选择我的角色
const changeJob = action((ev: SelectChangeEvent<unknown>) => {
  // console.log('我的角色 -- ', ev.target.value);
  moSetting.roleEmpty = false;
  moSetting.job = ev.target.value;
});

// 选择我所在的城市
const changeCity = action((ev: SelectChangeEvent<unknown>) => {
  // console.log('我所在的城市 -- ', ev.target.value);
  const arr: any[] = cloneDeep(moInfo.cityList);
  let code: number | string = '';
  arr.map((item: any) => {
    if (item.name === ev.target.value) code = item.code;
  });
  moSetting.city = ev.target.value;
  moSetting.cityCode = code;
});

// 选择企业规模
const changeScale = action((ev: SelectChangeEvent<unknown>) => {
  // console.log('企业规模 -- ', ev.target.value);
  const arr: any[] = cloneDeep(moInfo.scaleList);
  let code: number | string = '';
  arr.map((item: any) => {
    if (item.name === ev.target.value) code = item.code;
  });
  moSetting.scale = ev.target.value;
  moSetting.scaleCode = code;
});

// 选择企业性质
const changeNature = action((ev: SelectChangeEvent<unknown>) => {
  // console.log('企业性质 -- ', ev.target.value);
  const arr: any[] = cloneDeep(moInfo.natureList);
  let code: number | string = '';
  arr.map((item: any) => {
    if (item.name === ev.target.value) code = item.code;
  });
  moSetting.nature = ev.target.value;
  moSetting.natureCode = code;
});

// 提交
const onSure = action(async (callback: () => any) => {
  const { code, name } = moSingle;
  const token = Cookies.get('access_token') || '';
  const {
    industry, job, city, scale, nature,
    cityCode, scaleCode, natureCode,
  } = moSetting;

  if (!trim(name)) {
    moSetting.industryEmpty = true;
    return;
  }
  if (!trim(moSetting.job)) {
    moSetting.roleEmpty = true;
    return;
  }

  const params = {
    job, // 我的角色
    industry: { code, name }, // 我所在的行业
    city: { code: cityCode, name: city }, // 我所在的城市
    scale: { code: scaleCode, name: scale }, // 企业规模
    nature: { code: natureCode, name: nature }, // 企业性质
  };
  // console.log('参数 -- ', params);
  const res: any = await Service.chooseIndustry(token, params);
  if (res.code === 0) {
    localStorage.removeItem('regIndustry');
    localStorage.removeItem('regCity');
    localStorage.removeItem('regNature');
    localStorage.removeItem('regScale');

    toast.success('设置成功', {
      theme: 'dark',
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000,
      draggable: false,
      pauseOnFocusLoss: false,
      onClose: () => callback(),
    });
  }
});

export default moSetting;
export {
  changeIndustry, changeJob, changeCity, changeScale, changeNature, onSure,
  resetIndustryEmpty, reset,
};
